<template>
  <div class="authServer">
    <div class="leftContent">
      <el-scrollbar style="height: 100%">
        <leftTree
          v-if="showTree"
          :treeData="treeData"
          :defaultProps="defaultProps"
          @getTreeData="getTreeData"
          @addOrg="addOrg"
          @setCurrentNode="setCurrentNode"
          @editCurrentNode="editCurrentNode"
          @connectGroup="connectGroup"
        />
      </el-scrollbar>
    </div>
    <div class="rightContent">
      <div class="contentTop">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <svg-icon
                v-if="
                  currentNode.type == 'ORG' || currentNode.type == 'DEPARTMENT'
                "
                iconClass="govIcon"
              />
              <svg-icon
                v-if="currentNode.type == 'POSITION'"
                iconClass="peoIcon"
              />
              <span v-if="currentNode.type == 'POSITION'" class="mainName">{{
                currentNode.positionNameCn
              }}</span>
              <span
                v-if="
                  currentNode.type == 'ORG' || currentNode.type == 'DEPARTMENT'
                "
                class="mainName"
                >{{ currentNode.orgNameCn }}</span
              >
              <i
                class="el-icon-edit"
                @click="editOrg"
                v-if="
                  currentNode.type == 'POSITION' &&
                  buttonAuth.indexOf('position_edit') > -1
                "
              ></i>
              <i
                class="el-icon-edit"
                v-if="
                  (currentNode.type == 'ORG' ||
                    currentNode.type == 'DEPARTMENT') &&
                  buttonAuth.indexOf('org_edit') > -1
                "
                @click="editOrg"
              ></i>
            </div>
          </el-col>
          <el-col :span="2" :offset="10">
            <i
              class="el-icon-delete"
              style="color: #ffa600; cursor: pointer"
              @click="deleteOrgorPo"
              v-if="buttonAuth.indexOf('org_delete') > -1 && currentNode.type"
            ></i>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div
              class="grid-content bg-purple"
              v-if="currentNode.type == 'POSITION'"
            >
              <span>{{ $t(`authorization.organization.code`) }}</span>
              <span>:</span>
              <span>{{ currentNode.positionCode }}</span>
            </div>
            <div
              class="grid-content bg-purple"
              v-if="
                currentNode.type == 'ORG' || currentNode.type == 'DEPARTMENT'
              "
            >
              <span>{{ $t(`authorization.organization.code`) }}</span>
              <span>:</span>
              <span>{{ currentNode.orgCode }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div
              class="grid-content bg-purple-light"
              v-if="currentNode.type == 'DEPARTMENT'"
            >
              <span>{{ $t(`authorization.organization.type`) }}</span
              ><span>:</span
              ><span>{{ $t(`authorization.organization.department`) }}</span>
            </div>
            <div
              class="grid-content bg-purple-light"
              v-if="currentNode.type == 'ORG'"
            >
              <span>{{ $t(`authorization.organization.type`) }}</span
              ><span>:</span
              ><span>{{ $t(`authorization.organization.organization`) }}</span>
            </div>
            <div
              class="grid-content bg-purple-light"
              v-if="currentNode.type == 'POSITION'"
            >
              <span>{{ $t(`authorization.organization.positionType`) }}</span
              ><span>:</span
              ><span>{{ $t(`authorization.organization.position`) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div
              class="grid-content bg-purple"
              v-if="
                currentNode.type == 'ORG' || currentNode.type == 'DEPARTMENT'
              "
            >
              <span>{{ $t(`authorization.organization.phone`) }}</span>
              <span>:</span>
              <span>{{ currentNode.telephone }}</span>
            </div>
            <div
              class="grid-content bg-purple"
              v-if="currentNode.type == 'POSITION'"
            >
              <span>{{ $t(`common.status`) }}</span>
              <span>:</span>
              <span :class="currentNode.status == 'Y' ? 'yellow' : ''">{{
                currentNode.status == "N"
                  ? $t(`common.normal`)
                  : $t(`common.forbid`)
              }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottomTable">
        <Table
          ref="child"
          :tableConfig="tableConfig"
          :tableData="tableData"
          @callBackAction="callBackAction"
          :api="api"
          :type="type"
          @query="query"
          @add="add"
          @edit="edit"
          @remove="remove"
          @connectResourceGroup="connectResourceGroup"
          @exportFile="exportFile"
          :tableHeight="tableHeight"
          :currentNode="currentNode"
        />
      </div>
    </div>
    <Drawer
      v-if="showDrawer"
      :drawerType="drawerType"
      :showDrawer="showDrawer"
      @changeDrawer="changeDrawer"
      @addoreditOrg="addoreditOrg"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
    />
    <MemberDrawer
      v-if="showMemberDrawer"
      :showMemberDrawer="showMemberDrawer"
      @changeMemberDrawer="changeMemberDrawer"
      :drawerMode="drawerMode"
      :formData="formData"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      :currentNode="currentNode"
      @deleteResourceGroup="deleteResourceGroup"
      @addResourceGroup="addResourceGroup"
    />
    <ConnectGroup
      @confirmConnect="confirmConnect"
      v-if="showConnectDrawer"
      :drawerTyp="drawerType"
      :showDrawer="showConnectDrawer"
      @changeConnectDrawer="changeConnectDrawer"
      :drawerMode="drawerMode"
      @addoredit="addoredit"
      :type="type"
      :addoreditForm="addoreditForm"
      :drawerTitle="drawerTitle"
      @addResourceGroup="addResourceGroup"
      :handelNode="handelNode"
    />
    <Dialog
      :dialogFormVisible="dialogFormVisible"
      @setDialog="setDialog"
      :dialogType="dialogType"
      :dialogTitle="dialogTitle"
      :eventType="eventType"
      :addType="addType"
      :tableData="tableData2"
      :tableConfig="tableConfig2"
      width="660px"
    />
  </div>
</template>
<script>
import MemberDrawer from "../member/drawer.vue";
import ConnectGroup from "./connectGroupDrawer.vue";
import Drawer from "./addEditDrawer.vue";
import Dialog from "@/components/dialog/index.vue";
import leftTree from "@/components/leftTree/index.vue";
// import SearchForm from "@/components/searchForm/index.vue";
import Table from "@/components/table/index.vue";
import {
  getOrgTree,
  AddOrg,
  updateOrg,
  deleteOrg,
  deleteMember,
  addPosition,
  updatePosition,
  deletePosition,
  queryMember,
  queryMemberDetail,
  userRelResGroup,
  updateUser,
  addUser,
} from "@/api/authorization.js";

export default {
  components: { Table, leftTree, Drawer, Dialog, ConnectGroup, MemberDrawer },
  data() {
    return {
      showTree: false,
      tableHeight: document.documentElement.clientHeight - 400,
      editForm: {},
      addForm: {
        userInfo: [
          {
            prop: "userId",
            label: "authorization.member.userId",
            width: "180",
            required: true,
          },
          {
            prop: "userName",
            label: "authorization.member.userName",
            width: "180",
            required: true,
          },
          {
            prop: "rootOrgCode",
            label: "authorization.member.rootOrgCode",
            width: "180",
            required: true,
            disabled: true,
          }, //qcc
          {
            prop: "parentOrgCode",
            label: "authorization.member.parentOrgCode",
            width: "180",
            required: true,
          }, //qcc
          {
            prop: "branchCode",
            label: "authorization.member.branchCode",
            width: "180",
            required: false,
          },
          // {
          //   prop: "userKind",
          //   label: "authorization.member.userKind",
          //   width: "180",
          //   required: true,
          // },
          {
            prop: "contactNo",
            label: "authorization.member.contactNo",
            width: "180",
            required: false,
          },
          {
            prop: "email",
            label: "authorization.member.email",
            width: "180",
            required: false,
          },
        ],
        positionCodes: {
          prop: "positionCodes",
          width: "180",
          label: "authorization.member.positionCodes",
          placeholder: "authorization.member.positionRule",
          required: false,
        },
        loginInfo: [
          {
            prop: "loginId",
            label: "authorization.member.loginId",
            width: "180",
            required: true,
          },
          {
            prop: "loginPwd",
            label: "authorization.member.loginPwd",
            width: "180",
            required: true,
          },
          {
            prop: "effectiveDate",
            label: "authorization.member.effectiveDate",
            width: "180",
            required: false,
          },
          {
            prop: "pwdExpDate",
            label: "authorization.member.pwdExpDate",
            width: "180",
            required: false,
          },
        ],
      },
      showConnectDrawer: false,
      drawerType: "", //添加或编辑机构，添加或者编辑部门岗位
      deleteType: "",
      formInline: {},
      selectedItems: [],
      eventType: "",
      dialogTitle: "",
      dialogFormVisible: false,
      drawerTitle: "",
      addoreditForm: {},
      formData: [],
      showDrawer: false,
      showMemberDrawer: false,
      drawerMode: "add", //edit
      addType: "",
      dialogType: "",
      currentNode: {},
      handelNode: {},
      treeData: [],
      defaultProps: {
        children: "childNode",
        label: "label",
      },
      type: "organization",
      api: {},
      tableData: {},
      tableData2: {},
      searchConfig: {},
      tableConfig2: {},
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: this.$t(`common.inputKey`),
            },
          ],
          actions: [
            {
              type: "query",
              name: "common.query",
              event: "query",
              auth: "user_query",
            },
            { type: "add", name: "common.add", event: "add", auth: "user_add" },
            {
              type: "edit",
              name: "common.edit",
              event: "edit",
              auth: "user_edit",
            },
            {
              type: "remove",
              name: "common.remove",
              event: "remove",
              auth: "user_delete",
            },
            {
              type: "connectResourceGroup",
              name: "common.connectResourceGroup",
              event: "connectGroup",
              auth: "user_relgroup_add",
            },
            {
              type: "export",
              name: "common.exportMember",
              event: "export",
              auth: "user_export",
            },
          ],
        },
        table: {
          selection: true,
          columns: [
            {
              prop: "userId",
              label: `authorization.member.userId`,
              width: "",
            },
            {
              prop: "userName",
              label: `authorization.member.userName`,
              width: "",
            },
            // {
            //   prop: "userKind",
            //   label: `authorization.member.userKind`,
            //   width: "",
            // },
            {
              prop: "updateUser",
              label: `authorization.member.lastUpdater`,
              minWidth: "150px",
            },
            {
              prop: "updateTime",
              label: `authorization.member.lastUpdateTime`,
              minWidth: "150px",
            },
            { prop: "status", label: `common.status`, width: "" },
          ],
          action: {},
        },
      },
    };
  },
  created: function () {
    if (this.buttonAuth.indexOf("org_tree") > -1) {
      this.showTree = true;
      this.getTreeData();
    }
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth || [];
    },
  },
  methods: {
    // queryResourceGroup() {

    //   //查询资源分组，返回表单数据
    //   this.tableData2 = {
    //     data: [
    //       {
    //         ID: "23424234asea3",
    //         name: "王srs虎",
    //         email: "2423434@qq.com",
    //         job: "普通",
    //         status: "正常",
    //       },
    //       {
    //         ID: "234242343fcxv",
    //         name: "王sdf虎",
    //         email: "2423434@qq.com",
    //         job: "普通",
    //         status: "正常",
    //       },
    //     ],
    //   };
    //   this.tableConfig2 = {
    //     table: [
    //       { prop: "name", label: "姓名", width: "180" },
    //       { prop: "ID", label: "ID", width: "180" },
    //       { prop: "email", label: "邮箱", width: "250" },
    //       { prop: "job", label: "岗位", width: "180" },
    //       { prop: "status", label: "状态", width: "180" },
    //     ],
    //   };
    // },
    confirmDelete() {
      if (this.deleteType == "org") {
        console.log();
        if (this.currentNode.type == "POSITION") {
          //删除岗位
          deletePosition({ id: this.currentNode.id }).then((res) => {
            if (res.code == "AUTH_000000") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getTreeData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          //删除机构部门
          deleteOrg({ id: this.currentNode.id }).then((res) => {
            if (res.code == "AUTH_000000") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getTreeData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else {
        //删除项目，更新列表
        let arr = [];
        this.selectedItems.forEach((item) => {
          arr.push(item.id);
        });
        let data = { ids: arr };
        deleteMember(data).then((res) => {
          if (res.code == "AUTH_000000") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.query();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      }
      // let data=this.selectedItems
      // this.api["delete"](data).then(res=>{
      //refresh
      // this.handleCurrentChange();
      // this.query();
      // })
    },
    deleteItem() {
      //需要弹框二次确认
      this.dialogType = "yellowType";
      this.dialogTitle = this.$t("common.alert");
      this.dialogFormVisible = true;
      this.deleteType = "item";
    },
    addoredit(obj) {
      this.changeMemberDrawer(false);
      let data = obj;
      console.log(data);
      //去做保存
      //新增的话做保存
      if (this.drawerMode == "add") {
        addUser(data).then((res) => {
          if (res.code == "AUTH_000000") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.changeMemberDrawer(false);
            this.query();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        //编辑的话二次确认
        this.$alert(this.$t("common.confirmEdit"), this.$t("common.alert"), {
          confirmButtonText: this.$t("common.confirm"),
          callback: (val) => {
            if (val == "confirm") {
              updateUser(data).then((res) => {
                if (res.code == "AUTH_000000") {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.changeMemberDrawer(false);
                  this.query();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              });
            }
          },
        });
      }
    },
    addoreditOrg(form) {
      let data = form;
      if (data.type !== "POSITION") {
        data.city = form.city ? form.city.name : "";
        data.province = form.province ? form.province.name : "";
        data.area = form.area ? form.area.name : "";
        console.log("data", data);
      }
      if (this.drawerType == "addRoot") {
        //添加根机构
        data.orgType = "ORG";
        data.parentOrgCode = "root";
        data.rootOrgCode = data.orgCode;
        AddOrg(data).then((res) => {
          if (res.code == "AUTH_000000") {
            this.$message({
              type: "success",
              message: res.msg,
            });
            //刷新树结构l
            this.getTreeData();
            this.changeDrawer(false);
          } else {
            return this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
        //去做保存
      } else if (this.drawerType == "editRoot") {
        //编辑根机构
        data.orgType = "ORG";
        data.parentOrgCode = "root";
        data.rootOrgCode = data.orgCode;
        this.editForm = data;
        //二次确认
        this.dialogTitle = this.$t(`common.alert`);
        this.dialogFormVisible = true;
        this.eventType = "confirmEdit";
        this.dialogType = "normalType";
        this.changeDrawer(false);
      } else if (this.drawerType == "editChild") {
        //编辑机构或者岗位
        if (data.type == "DEPARTMENT") {
          data.orgType = "DEPARTMENT";
          data.parentOrgCode = this.currentNode.orgCode;
          data.rootOrgCode = this.currentNode.rootOrgCode;
          this.editForm = data;
          //二次确认
          this.dialogTitle = this.$t(`common.alert`);
          this.dialogFormVisible = true;
          this.eventType = "confirmEdit";
          this.dialogType = "normalType";
        } else {
          data.orgType = "POSITION";
          data.parentOrgCode = this.currentNode.orgCode;
          data.rootOrgCode = this.currentNode.rootOrgCode;
          this.editForm = data;
          //二次确认
          this.dialogTitle = this.$t(`common.alert`);
          this.dialogFormVisible = true;
          this.eventType = "confirmEdit";
          this.dialogType = "normalType";
        }
        this.changeDrawer(false);
      } else if (this.drawerType == "addChild") {
        //新增机构或者岗位
        if (data.type == "DEPARTMENT") {
          data.orgType = "DEPARTMENT";
          data.parentOrgCode = this.currentNode.orgCode;
          data.rootOrgCode = this.currentNode.rootOrgCode;
          AddOrg(data).then((res) => {
            if (res.code == "AUTH_000000") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              //刷新树结构
              this.getTreeData();
              this.changeDrawer(false);
            } else {
              return this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          //新增岗位
          data.orgType = "POSITION";
          data.parentOrgCode = this.currentNode.orgCode;
          data.rootOrgCode = this.currentNode.rootOrgCode;
          this.editForm = data;
          //二次确认
          addPosition(data).then((res) => {
            if (res.code == "AUTH_000000") {
              this.$message({
                type: "success",
                message: res.msg,
              });
              //刷新树结构
              this.getTreeData();
              this.changeDrawer(false);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      }
    },
    changeDrawer(v) {
      this.showDrawer = v;
    },
    changeMemberDrawer(v) {
      this.showMemberDrawer = v;
    },
    getTreeData() {
      //异步请求
      getOrgTree().then((res) => {
        this.treeData = res.data;
        //把之前选中的清空
        this.currentNode = {};
      });
    },
    callBackAction(param) {
      this.selectedItems = param.selectedItems;
      this.formInline = param.formInline;
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    query(v) {
      let data = {
        currentPage: v ? v.formInline.currentPage : 1,
        pageSize: v ? v.formInline.pageSize : 10,
        condition: {
          vagueParam: v ? v.formInline.inputKey : "",
          parentOrgCode: this.currentNode.orgCode || "", //如果有选择且是组织机构
          positionCode: this.currentNode.positionCode || "", //如果有选择且是岗位,
        },
      };
      //查询成员接口
      queryMember(data).then((res) => {
        this.tableData = res.data;
        this.$nextTick(() => {
          this.$refs.child.$refs.multipleTable.clearSelection();
        });
      });
    },
    add() {
      this.addoreditForm = {};
      this.showMemberDrawer = true;
      this.drawerMode = "add";
      this.drawerTitle = this.$t(`authorization.addMember`);
      this.formData = this.addForm;
    },
    edit() {
      if (this.selectedItems.length > 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      let data = {
        id: this.selectedItems[0].id,
      };
      //动态请求详情
      queryMemberDetail(data).then((res) => {
        this.changeMemberDrawer(true);
        this.drawerMode = "edit";
        this.drawerTitle = this.$t(`authorization.editMember`);
        this.formData = this.addForm;
        this.addoreditForm = res.data;
      });
    },
    remove() {
      this.deleteItem();
    },
    connect() {},
    export() {},
    deleteResourceGroup(items) {
      console.log(items);
      //弹框二次确认
      //删除抽屉里面的资源组
    },
    addOrg(type) {
      //以上错误，使用弹框填写名称
      //区分是编辑还是新增，是一级组织还是部门岗位
      this.drawerMode = "add";
      this.drawerTitle = this.$t(`common.add`);
      this.addoreditForm = {};
      this.drawerType = type;
      // if (type == "addRoot") {
      //   // this.formData = [
      //   //   { prop: "orgCode", label: "机构编码", width: "180", required: true ,inputType:"select",disabled:true },
      //   //   { prop: "orgName", label: "英文名称", width: "180", required: true ,inputType:"input"},
      //   //   { prop: "orgNameCn", label: "中文名称", width: "180", required: true ,inputType:"input"},
      //   //   { prop: "orgType", label: "组织类别", width: "180", required: true ,inputType:"select"},
      //   //   { prop: "status", label: "状态", width: "180", required: true ,inputType:"input"},
      //   //   { prop: "telephone", label: "地区", width: "180", required: true ,inputType:"input"},
      //   //   { prop: "remark", label: "备注", width: "180", required: true ,inputType:"input"},
      //   // ];
      // } else
      if (type == "addChild") {
        //新增岗位或者部门
        this.drawerMode = "add";
        this.drawerTitle = this.$t(`common.add`);
        this.addoreditForm = {};
        this.drawerType = type;
      }
      this.changeDrawer(true);
      // this.addType = type;
      // this.dialogType = "normalType";
      // this.dialogTitle = "新增";
      // this.dialogFormVisible = true;
    },
    editOrg() {
      this.drawerMode = "edit";
      this.drawerTitle = this.$t(`common.edit`);
      this.addoreditForm = this.currentNode;
      if (this.currentNode.type == "ORG") {
        //说明是编辑根机构
        this.drawerType = "editRoot";
      } else if (this.currentNode.type == "DEPARTMENT") {
        //编辑部门
        this.drawerType = "editChild";
      } else {
        //编辑岗位
        this.drawerType = "editChild";
      }
      // this.drawerMode = "edit";
      // this.changeDrawer(true);
      // this.addoreditForm = this.currentNode;
      // this.formData = [
      //   { prop: "name", label: "名称", width: "380" },
      //   { prop: "no", label: "编号", width: "380" },
      //   { prop: "type", label: "类型", width: "380" },
      //   { prop: "tel", label: "电话", width: "380" },
      // ];
      this.changeDrawer(true);
    },
    // addoreditOrg() {
    //   if (this.type == "add") {
    //     //调用添加接口，结果message提示
    //     //刷新右侧树状图
    //   } else if (this.type == "edit") {
    //     //调用编辑接口，结果message提示
    //     //刷新右侧树状图
    //   }
    // },
    deleteOrgorPo() {
      //二次确认弹窗
      this.dialogType = "yellowType";
      this.dialogTitle = this.$t(`common.alert`);
      this.dialogFormVisible = true;
      this.deleteType = "org";
    },
    setCurrentNode(val) {
      this.currentNode = val.details;
      this.currentNode.type = val.type;
      this.currentNode.label = val.label;
      //重置右侧的搜索和表格
      this.tableData = {};
      this.$refs["child"].reset();
    },
    editCurrentNode(val, flag) {
      //当前操作的树节点
      this.handelNode = val.details;
      this.handelNode.type = val.type;
      this.handelNode.label = val.label;
      console.log("val-handelNode", this.handelNode);
      if (flag == "connect") {
        this.connectResourceGroup();
      }
    },
    setDialog(v, form) {
      console.log("form", form);
      if (v) {
        //是编辑保存
        if (this.dialogType == "normalType") {
          if (this.drawerType == "editRoot") {
            console.log("5", this.editForm);
            //编辑根机构
            updateOrg(this.editForm).then((res) => {
              if (res.code == "AUTH_000000") {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.showDrawer = false;
                //更新查询
                this.getTreeData();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          } else if (this.drawerType == "editChild") {
            //编辑部门或者岗位
            if (this.currentNode.type == "DEPARTMENT") {
              //如果是部门
              updateOrg(this.editForm).then((res) => {
                if (res.code == "AUTH_000000") {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.showDrawer = false;
                  //更新查询
                  this.getTreeData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              });
            } else {
              //如果是岗位
              updatePosition(this.editForm).then((res) => {
                if (res.code == "AUTH_000000") {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.showDrawer = false;
                  //更新查询
                  this.getTreeData();
                } else {
                  this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              });
            }
          }
        } else {
          //是确认删除
          this.confirmDelete();
        }
      }
      this.dialogFormVisible = false;
      // if (v) {
      //   //是保存或删除
      //   if (form === {}) {
      //     if (items) {
      //       //添加资源组
      //       //刷新抽屉
      //     } else {
      //       this.confirmAddOrg(form);
      //     }
      //   } else {
      //     //删除组织或项目
      //     this.confirmDelete();
      //   }
      // }
      // this.dialogFormVisible = false;
    },
    confirmAddOrg(form) {
      console.log(form);
      //调用接口
      //刷新右侧树状图
    },
    connectGroup() {
      //成员关联
      this.handelNode = this.selectedItems[0];
      this.connectResourceGroup();
    },
    connectResourceGroup() {
      if (this.selectedItems.length > 1) {
        this.$message({
          type: "info",
          message: this.$t(`authorization.member.onlyChooseOne`),
        });
        return;
      }
      //区分是岗位关联还是成员关联
      this.drawerMode = "connectResourceGroup";
      this.drawerTitle = this.$t(`common.connectResourceGroup`);
      this.showConnectDrawer = true;
    },
    addResourceGroup() {
      this.dialogFormVisible = true;
      this.dialogType = "normalType";
      (this.dialogTitle = this.$t(`common.add`)),
        (this.eventType = "addResourceGroup");
    },
    confirmConnect(val) {
      let arr = [];
      val.forEach((item) => {
        arr.push(item.resGroupCode);
      });
      //确认岗位关联资源分组relResGroup
      let data = {
        positionCode: this.handelNode.positionCode,
        rootOrgCode: this.handelNode.rootOrgCode,
        resGroupCodes: arr,
      };
      console.log(data);
      //去请求
      userRelResGroup(data).then((res) => {
        if (res.code === "AUTH_000000") {
          this.showConnectDrawer = false;
        }
        this.$message({
          type: res.code === "AUTH_000000" ? "success" : "warning",
          message: res.msg,
        });
      });
    },
    changeConnectDrawer(v) {
      this.showConnectDrawer = v;
    },
    exportFile() {
      //下载表格
    },
  },
};
</script>
<style lang="less" scoped>
.leftContent {
  background-color: pink;
  float: left;
  width: 320px;
  height: calc(100% - 10px);
  margin: 0 2px 10px 10px;
  background-color: white;
  border-radius: 4px 0 0 4px;
}
.rightContent {
  background-color: white;
  float: left;
  width: calc(100% - 345px);
  height: 100%;
}
.contentTop {
  padding: 20px;
  background-color: #f7f7f7;
  height: 40px;
  margin: 10px;
  line-height: 20px;
  border-radius: 0 4px 4px 0;
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #303133;
  // letter-spacing: 0;
  font-weight: 400;
}
.mainName {
  // font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #303133;
  // letter-spacing: 0;
  font-weight: 600;
}
.el-icon-edit {
  cursor: pointer;
}
.yellows {
  color: #ffa600;
}
.bottomTable {
  padding: 10px;
}
</style>
